import React from 'react';
import aboutImage from '../assets/aboutus.jpg';
import { Link } from 'react-router-dom';

const AboutUs = () => {
    return (
        <section className="about-us-section">
            <style>
                {`
                    .about-us-section {
                        background-color: #FFFDF7;
                        overflow: hidden;
                    }
                    .text-brown {
                        color: #5A3411;
                    }
                    .about-image {
                        border-radius: 12px;
                        box-shadow: 0 10px 30px rgba(0,0,0,0.05);
                        max-height: 500px;
                    }
                    .about-list {
                        list-style: none;
                        padding: 0;
                    }
                    .about-list li {
                        display: flex;
                        align-items: center;
                    }
                    .about-list li::before {
                        content: "•";
                        color: #5A3411;
                        font-size: 1.5rem;
                        margin-right: 10px;
                        line-height: 1;
                    }
                    .btn-about {
                        background-color: #F88924;
                        color: white;
                        padding: 12px 32px;
                        border-radius: 50px;
                        font-weight: 700;
                        transition: background-color 0.3s ease;
                        border: none;
                    }
                    .btn-about:hover {
                        background-color: #e07612;
                        color: white;
                    }
                `}
            </style>
            <div className="container py-5">
                <div className="row align-items-stretch gx-lg-5 gy-5">
                    <div className="col-lg-6">
                        <div className="position-relative h-100">
                            <img
                                src={aboutImage}
                                alt="Children in nursery"
                                className="img-fluid about-image w-100 h-100"
                                style={{ objectFit: 'cover' }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 text-brown">
                        <h2 className="display-4 fw-bold mb-4">About Us</h2>
                        <p className="fs-6 mb-4 lh-base opacity-75">
                            Zubis Nursery is a family-run setting where we blend the warmth of home with the wonder of learning.
                        </p>
                        <p className="fs-6 mb-4 lh-base opacity-75">
                            We believe every child is curious, capable, and full of potential. Our passionate team of educators create an environment that encourages children to:
                        </p>
                        <ul className="about-list mb-4">
                            <li className="fs-6 fw-bold mb-2 opacity-100" style={{ WebkitTextStroke: '0.5px #5A3411' }}>Explore and ask questions</li>
                            <li className="fs-6 fw-bold mb-2 opacity-100" style={{ WebkitTextStroke: '0.5px #5A3411' }}>Think creatively and critically</li>
                            <li className="fs-6 fw-bold mb-2 opacity-100" style={{ WebkitTextStroke: '0.5px #5A3411' }}>Grow in confidence and independence</li>
                        </ul>
                        <Link to="/about" className="btn btn-about text-decoration-none">Learn More</Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutUs;
